export const USER_TYPES = Object.freeze([
  {
    id: "staff",
    title: "Штатный сотрудник",
  },
  {
    id: "freelancer",
    title: "Аутсорс сотрудник",
  },
  {
    id: "administrative",
    title: "Административный сотрудник",
  },
  {
    id: "staff-special",
    title: "Сотрудник с расчетом от планового времени",
  },
]);

export const USER_TYPES_ARRAY = Array.from(USER_TYPES, (item) => ({
  id: item.id,
  title: item.title,
}));
